<div class="auth-page-wrapper">
  <div class="auth-form-container auth-form-side">
    <div class="auth-card" style="max-width:500px;width:100%">
        <div class="password-header">
          <img src="assets/logo.png" alt="Radio Ads Direct" class="password-logo" />
          <div class="auth-icon-wrap auth-icon-wrap--green" style="margin:0 auto 1rem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
          <h1 class="auth-heading" style="text-align:center">{{getPageTitle()}}</h1>
          <p class="auth-subheading" style="text-align:center">{{getPageDescription()}}</p>
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="password-form">
          <div class="form-section">
            <div class="auth-field auth-field--has-icon">
              <input
                class="auth-input"
                formControlName="password"
                [type]="showPassword ? 'text' : 'password'"
                placeholder=" "
                >
              <label>New Password</label>
              <button type="button" mat-icon-button matSuffix class="auth-field__icon-btn" (click)="showPassword = !showPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showPassword">
                <mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
              </button>
              @if (passwordControl?.invalid && passwordControl?.touched) {
                <mat-error class="auth-error">
                  @if (passwordControl?.errors?.['required']) {
                    Password is required
                  } @else if (passwordControl?.errors?.['minlength']) {
                    Password must be at least 8 characters
                  }
                </mat-error>
              }
            </div>

            <!-- Password Strength Indicator -->
            @if (passwordControl?.value && passwordStrength) {
              <div class="password-strength {{passwordStrength}}">
                {{getPasswordStrengthText(passwordStrength)}}
              </div>
            }

            <div class="auth-field auth-field--has-icon">
              <input
                class="auth-input"
                formControlName="confirmPassword"
                [type]="showConfirmPassword ? 'text' : 'password'"
                placeholder=" "
                >
              <label>Confirm New Password</label>
              <button type="button" mat-icon-button matSuffix class="auth-field__icon-btn" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showConfirmPassword">
                <mat-icon>{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
              </button>
              @if (confirmPasswordControl?.invalid && confirmPasswordControl?.touched) {
                <mat-error class="auth-error">
                  @if (confirmPasswordControl?.errors?.['required']) {
                    Please confirm your password
                  } @else if (confirmPasswordControl?.errors?.['passwordMismatch']) {
                    Passwords do not match
                  }
                </mat-error>
              }
            </div>
          </div>

          <!-- Password Requirements -->
          <div class="auth-password-hint">
            <strong>Password must contain:</strong>
            <ul>
              <li>At least 8 characters</li>
              <li>One uppercase letter (A-Z)</li>
              <li>One number (0-9)</li>
              <li>One special character (!&#64;#$...)</li>
            </ul>
          </div>

          <!-- Error Message -->
          @if (error) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              <span>{{error}}</span>
            </div>
          }

          <!-- Success Message -->
          @if (success) {
            <div class="success-message">
              <mat-icon>check_circle</mat-icon>
              <span>{{success}}</span>
            </div>
          }

          <!-- Submit Button -->
          <div class="form-actions">
            @if (loading) {
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="password-button btn-primary btn-full btn-lg"
                disabled>
                <span class="btn-spinner"></span>
                Setting Password...
              </button>
            } @else {
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="password-button btn-primary btn-full btn-lg"
                [disabled]="passwordForm.invalid">
                Set Password
              </button>
            }
          </div>
        </form>

        <!-- Footer -->
        <div class="password-footer">
          <p class="auth-footer">Need help? <a routerLink="/login" class="help-link">Back to Login</a></p>
        </div>
    </div>
  </div>
  <div class="auth-image-container">
    <img src="assets/auth/passwordImage.webp" alt="Set Password Image">
  </div>
</div>
